import { IRefundDetailResponse } from '@/types/refund';
import { AxiosError } from 'axios';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { useAppSelector } from './useReduxHooks';
import { getPaymentHistory } from '@/api/payment';
import { GetPaymentHistoryResponse } from '@/types/payment.type';

export const useGetPaymentHistory = () => {
  const [size, setSize] = useState(500);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [keyword, setKeyword] = useState('');
  const [enabled, setEnabled] = useState(false);
  const { filter } = useAppSelector((state) => state.refund);
  const { hospitalId } = useAppSelector((state) => state.user);
  const params = {
    page: pageNumber,
    size,
    startDate: format(filter.startDate, 'yyyy-MM-dd'),
    endDate: format(filter.endDate, 'yyyy-MM-dd'),
    keyword,
    hospitalId,
  };

  useEffect(() => {
    setEnabled(true);
    return () => setEnabled(false);
  }, [filter]);

  const { data, refetch, isLoading } = useQuery<
    GetPaymentHistoryResponse,
    AxiosError
  >(['paymentDetail', params, filter], () => getPaymentHistory(params), {
    onSuccess: (res) => {
      setTotalPage(res.totalPages);
    },
    retry: false,
    enabled,
    keepPreviousData: true,
  });

  return {
    data,
    totalPage,
    refetch,
    pageNumber,
    setPageNumber,
    setSize,
    isLoading,
    setKeyword,
  };
};
